import { Injectable } from '@angular/core';
import { Owner, User } from 'cargo-chief-commons';
import { ACTIVE_USERS, ALL_ACCOUNT_USERS } from '@shared/utils/account-users';
import { AccessCacheService } from '@service/access-cache/access-cache.service';

@Injectable({
	providedIn: 'root',
})
export class UsersService {
	constructor(private accessCacheService: AccessCacheService) {}

	public getActiveUsers(userIds: number[] = []): Owner[] {
		return this.filterByIds(ACTIVE_USERS(this.accessCacheService.getAccountUsers()), userIds);
	}

	// Every account user regardless of status, for resolving labels of existing assignments.
	public getAllAccountUsers(userIds: number[] = []): Owner[] {
		return this.filterByIds(ALL_ACCOUNT_USERS(this.accessCacheService.getAccountUsers()), userIds);
	}

	private filterByIds(users: Owner[], userIds: number[]): Owner[] {
		if (userIds.length == 0) {
			return users;
		}
		return users.filter((user) => userIds.includes(user.userId));
	}

	public getUsersById(userIds: number[]): User[] {
		return this.accessCacheService.getAccountUsers().filter((user: User) => {
			return userIds.includes(user.id);
		});
	}
}
